import { render, staticRenderFns } from "./UsersSection.vue?vue&type=template&id=c5e1d7ba&scoped=true&"
import script from "./UsersSection.vue?vue&type=script&lang=js&"
export * from "./UsersSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5e1d7ba",
  null
  
)

export default component.exports